import React, { PureComponent } from 'react';
import { Icon, Input, Badge } from 'antd'
import { connect } from "react-redux";

class SearchArea extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            showSearch: false,
            search_keyword: ''
        };
    }
    componentDidMount() { 
        window.onkeydown = function(e){
            var ck = e.keyCode ? e.keyCode : e.which;
            if(e.ctrlKey && ck == 70){
                document.querySelector('.ant-dropdown-search').click();
                if(document.querySelector('#search-strudent-input')) {
                    document.querySelector('#search-strudent-input').focus();
                }                
                return false;
            } else if(ck == 27) {
                document.querySelector('.ant-dropdown-search').click();
                if(document.querySelector('#search-strudent-input')) {
                    document.querySelector('#search-strudent-input').focus();
                }
                return false;
            }
        } 
        
        let searchParams = new URLSearchParams(this.props.search);
        let studentSearch = searchParams.get("keyword");
        
        if(studentSearch) {
            this.setState({search_keyword: studentSearch});
        }    
    }
    checkActiveKey = (e) => {
        var ck = e.keyCode ? e.keyCode : e.which;
        if(ck == 13) {
            window.location.href="/student-search?keyword="+this.state.search_keyword;
        }
    }
    render() {
        const { showSearch, search_keyword } = this.state;
        
        const menu = (
            <div className="ant-search-dropdown">
                <div  className="ant-search-dropdown-input" >
                    <Input 
                        type='text' 
                        value={search_keyword} 
                        onChange={(e) => {this.setState({search_keyword: e.target.value})}} 
                        onKeyPress={(e) => {this.checkActiveKey(e)}}
                        placeholder="Search Student" 
                        id='search-strudent-input'
                    />
                </div>
            </div>
        );

        return (
            <div className="ant-dropdown-open ant-dropdown-search-group">
                <Badge >
                    <Icon type="search" onClick={() => { this.setState({showSearch: (showSearch == true ? false : true)})}} className="ant-dropdown-search" />
                </Badge>
                {showSearch ? menu : false}
            </div>
        )
    }
}
const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search,
  });
  
  const mapDispatchToProps = (dispatch) => {
    return {
      dispatch,
    };
  };
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(SearchArea);